import i18next from 'i18next';
import XHR from 'i18next-xhr-backend';

export const i18n = (translationsApi: string, keys?: string[]) => {
  if (!Array.isArray(keys) || !keys.length) {
    void i18next.init({});

    return i18next;
  }

  const translationsUrl = new URL(translationsApi, window.location.origin);

  keys.forEach((key) => {
    translationsUrl.searchParams.append('keys', key);
  });

  void i18next.use(XHR).init({
    backend: {
      loadPath: translationsUrl,
    },
    keySeparator: '::',
  });

  return i18next;
};
